import { getToken } from "@/utils/auth";
import service from "@/utils/request";

export const getAllProjects = async (page) => {
    try{
        const response = await service.get('/projects?page='+page);
        return response;
    }catch(e){
        console.error("Failed to fetch Units:", e);
    }
}

export const deleteProj = async (id) => {
    try{
        const response = await service.delete('/projects/'+id);
        return response;
    }catch(e){
        console.error("Failed to delete Project:", e);
    }
}

export const UpdateProject = async ( project) => {
    try{
        const response = await service.post('/projects/'+project.id , project);
        return response;
    }catch(e){
        console.error("Failed to update Unit:", e);
    }
}
export const addProject = async (project) => {
    try{
        console.log(project);
        const response = await service.post('/projects', project, {

            headers: {
                'Content-Type': 'multipart/form-data',  // Important for file uploads
            }
        });
        return response;
    }catch(e){
        console.error("Failed to Add Project:", e);
    }
}
export const search = async ( value , page) => {
    try{
        const response = await service.get('/projects?page='+page+'&search='+value);
        return response;
    }catch(e){
        console.error("Failed to update Unit:", e);
    }
}

